"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unfilled = exports.filled = void 0;

var colors_1 = require("../../../styles/colors");

exports.filled = {
  500: colors_1.gray[100],
  700: colors_1.gray[300],
  900: colors_1.gray[500]
};
exports.unfilled = {
  500: colors_1.transparent,
  700: colors_1.gray[100],
  900: colors_1.gray[300]
};